import { useState } from 'react'

/**
 * Custom hook for managing table filters
 * Provides update, reset, and clear functionality for filter state
 * 
 * @param {Object} initialFilters - Initial filter values
 * @returns {Object} Filter state and handlers
 */
export function useTableFilters(initialFilters = {}) {
    const [filters, setFilters] = useState(initialFilters)

    /**
     * Update a single filter value
     * @param {string} key - Filter key to update
     * @param {any} value - New value for the filter
     */
    const updateFilter = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }))
    }

    /**
     * Reset all filters to initial values
     */
    const resetFilters = () => {
        setFilters(initialFilters)
    }

    /**
     * Clear a specific filter (remove from state)
     * @param {string} key - Filter key to remove
     */
    const clearFilter = (key) => {
        setFilters(prev => {
            const newFilters = { ...prev }
            delete newFilters[key]
            return newFilters
        })
    }

    /**
     * Update multiple filters at once
     * @param {Object} updates - Object with filter updates
     */
    const updateFilters = (updates) => {
        setFilters(prev => ({ ...prev, ...updates }))
    }

    return {
        filters,
        updateFilter,
        resetFilters,
        clearFilter,
        updateFilters,
        setFilters,
    }
}
